import {Image} from '@shopify/hydrogen';
import iconClose from '../../assets/icons/icon-close.svg';
import {PortableText} from '@portabletext/react';

import {TransitionVisible} from './TransitionVisible';
import {TypedObject} from '@sanity/types/dist/dts/index';
import clsx from 'clsx';
import {DATA_TEST_IDS} from '~/lib/const';

interface HeroOverlayProps {
  title?: TypedObject[];
  type: 'hero' | 'fiftyFifty';
  visible?: boolean;
  setVisible?: (visible: boolean) => void;
  testid?: string;
}

export function HeroOverlay({
  title,
  type,
  visible = false,
  setVisible,
  testid,
}: HeroOverlayProps) {
  return (
    <>
      <TransitionVisible show={visible}>
        <div
          data-testid={testid}
          className={clsx(
            'inset-0 absolute bg-gradient-to-b from-transparent to-black/80 flex items-end',
            {
              'pl-[97px] pb-[70px]': type === 'hero',
              'pl-[49px] pb-[90px]': type === 'fiftyFifty',
            },
          )}
        >
          <span
            className={clsx(
              'font-header text-xl text-white line-clamp-2 overlay-text',
              {
                'w-[486px]': type === 'hero',
                'w-3/4': type === 'fiftyFifty',
              },
            )}
          >
            {title && (
              <PortableText
                value={title}
                components={{
                  block: ({children}) => <>{children}</>,
                }}
              />
            )}
          </span>
        </div>
      </TransitionVisible>

      <TransitionVisible show={visible}>
        <button
          data-testid={DATA_TEST_IDS.BUTTON('fifty-modal-close')}
          type="button"
          className={clsx(
            'absolute w-11 h-11 bg-white rounded-full shadow-all cursor-pointer z-[2px] md:flex justify-center items-center hidden',
            {
              'right-[30px] bottom-[50px]': type === 'hero',
              'right-[49px] bottom-[52px]': type === 'fiftyFifty',
            },
          )}
          onClick={() => setVisible?.(false)}
        >
          <Image
            loading="lazy"
            src={iconClose}
            width="16.08px"
            height="16.08px"
            alt="Close overlay"
          />
        </button>
      </TransitionVisible>

      <TransitionVisible show={!visible}>
        <button
          data-testid={DATA_TEST_IDS.BUTTON('fifty-modal')}
          type="button"
          className={clsx(
            'absolute w-11 h-11 bg-white rounded-full shadow-all cursor-pointer z-[2px] md:flex hidden justify-center items-center space-x-[3.62px]',
            {
              'right-[30px] bottom-[50px]': type === 'hero',
              'right-[49px] bottom-[52px]': type === 'fiftyFifty',
            },
          )}
          onClick={() => setVisible?.(true)}
        >
          <div className="w-[5.32px] h-[5.32px] bg-black rounded-full" />
          <div className="w-[5.32px] h-[5.32px] bg-black rounded-full" />
          <div className="w-[5.32px] h-[5.32px] bg-black rounded-full" />
        </button>
      </TransitionVisible>
    </>
  );
}
